module.exports = new __parcel__URL__("pvp_restore_button.b59d1a5a.png").toString();